import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Box,
  ButtonBase,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  makeStyles,
  Typography,
  TextField,
} from '@material-ui/core';
import _, { isFunction } from 'lodash';
import moment from 'moment';
import { KeyboardDatePicker } from '@material-ui/pickers';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { KeyboardTimeInput } from '../../../../../components';
import { CloseIcon, DateIcon, SeeIcon } from '../../../../../components/Icon';
import Text from '../../../../../components/Text';
import MdroInfo from '../../../../../components/MdroInfo';
import { i18n } from '../../../../../language';
import BedStatusIcon from '../../BedStatusIcon';
import { baseCssOccupieddischarge } from '../baseCss';
import Dischargeconfirmation from '../Dischargeconfirmation';
import bsApp, { bedP, bedP as P, remarkType } from '../../../bsApp';
import { bsAttentionFunc } from '../../../bsAttention';
import { bedStatusAPI, eadmissionAPI } from '../../../../../apis';
import { classNames, initValue } from '../../../../../utils';
import { checkSubmitData } from '../../../../../utils/check';
import TransferOutPop from '../TransferOutPop';
import { alertMsg, ResponseCommCodeEnum } from '../../../../../apis/commlogic';
import eventBus from '../../../../../utils/eventBus';
import Newbooking from '../Newbooking';
import ReturnDayCaseConfirmation from '../ReturnDayCaseConfirmation';
import { OrderedCleaningService } from '../../ServiceOrder';
import ServiceOrderBtn from '../../ServiceOrder/ServiceOrderBtn';
import handleGetBsCleansingType from '../../../../../utils/handleGetBsCleansingType';
import admissionUtil from '../../../../../utils/admissionUtil';
import { PatientUI } from '../../InternalBooking/TransferInTable/Row';
import { getLsolationPrecaution, getAttention, isNotEmptyArray } from '../../../../../utils/newBedStatusUtil';
import CmsAlert, { CMS_ALERT_ICON_VARIANT } from '../../../../../components/CmsAlert';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      width: '80%',
      minWidth: '60rem',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      boxShadow: 'unset',
    },
  },
  root: {
    // width: '80rem',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    background: '#fff',
    minHeight: '45rem',
    overflow: 'auto',
    minWidth: '100%',
    maxWidth: '80rem',
  },
  remarksTextField: {
    width: '100%',
    height: '7rem',
    border: '1px solid #e4e7eb',
    padding: '1.25rem 1rem',
    backgroundColor: '#fff',
    borderRadius: '10px',
    lineHeight: '1.8rem',
    '& .MuiInput-root': {
      height: '100%',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Regular',
      fontSize: '1rem',
      color: '#2e4469',
    },
    '& :before': {
      content: 'none',
    },
    '& :after': {
      content: 'none',
    },
  },

  remaksText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    fontWeight: '500',
    color: '#2e4469',
    marginLeft: '0.688rem',
  },
  isolationPrecaution: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#2e4469',
    margin: '1.25rem 0 0.375rem 0',
  },
  addIcon: {
    width: '1.125rem',
    height: '1.125rem',
    color: '#538fff',
    marginRight: '0.813rem',
  },
  addAttention: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#538fff',
  },
  attentionItem: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    paddingTop: '0.5rem',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
  },
  attentionItemLabel: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: '#2e4469',
    paddingTop: '0.5rem',
    fontWeight: 'bold',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
    marginRight: '0.5rem',
  },
  datepicker: {
    width: '100%',
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
      height: '3.5rem',
      lineHeight: '3.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      borderRadius: '0.625rem',
      border: 'solid 1px #e4e7eb',
      backgroundColor: '#fff',
      padding: '0 1.25rem',
      fontSize: '1rem',
    },
    '& .MuiInputBase-input': {
      height: '3.5rem',
      lineHeight: '3.5rem',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 50%',
    padding: '1.5rem 2rem 2rem 0 ',
    overflow: 'overlay',
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 50%',
    paddingLeft: '1rem',
    paddingBottom: '2rem',
    borderLeft: '1px solid #e4e7eb',
  },
  statusBox: {
    marginTop: '1.5rem',
  },
  closeIconBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    marginRight: '7rem',
    marginTop: '1.5rem',
  },
  closeIcon: {
    fontSize: '1.375rem',
    position: 'absolute',
  },
  returnDayCase: {
    fontSize: '1rem',
    color: '#2e4469',
    fontFamily: 'NotoSans-Regular',
  },
  remarksBox: {
    backgroundColor: '#f5faff',
    padding: '0 1rem 1rem',
    borderRadius: '12px',
    margin: '1.5rem 0',
  },
  remarksTitle: {
    fontSize: '1.25rem',
    color: '#1973e6',
    fontFamily: 'NotoSans-Bold',
    fontWeight: 'bold',
  },
  configBtn: {
    width: '15.625rem',
    height: '3rem',
    borderRadius: '10px',
    color: '#fff',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    textAlign: 'center',
    background: '#fff',
  },
  colorBlue: {
    backgroundColor: '#4c93ff',
  },
  colorBabyBlue: {
    backgroundColor: '#82ddf0',
  },
  colorGreen: {
    backgroundColor: '#28d2ab',
  },
  colorRed: {
    backgroundColor: '#ff7270',
  },
  colorPurple: {
    backgroundColor: '#A711AE',
  },
  saveRemark: {
    width: '9.375rem',
    height: '3rem',
    backgroundColor: '#fff',
    borderRadius: '12px',
    fontSize: '1rem',
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    textAlign: 'center',
    border: '1px solid #538fff',
    marginTop: '1.125rem',
  },
  returnedDate: {
    fontSize: '1rem',
    color: '#2e4469',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  error: {
    borderColor: '#f44336 !important',
  },
  seeBtn: {
    width: '2.25rem',
    height: '2.25rem',
    minWidth: '2.25rem',
    backgroundColor: '#4c93ff',
    borderRadius: '0.625rem',
    color: '#fff',
    marginLeft: '2rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  seeIcon: {
    fontSize: '1.5rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  rightSpace: {
    marginRight: '0.5rem',
  },
}));

const initSchema = () => ({
  date: [P.missing]
    ? Yup.date()
        .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_DATE') }))
        .typeError(i18n.t('BEDSTATUS_INVALID_DATE_FORMAT'))
    : null,
  time: [P.missing]
    ? Yup.date()
        .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_TIME') }))
        .typeError(i18n.t('BEDSTATUS_INVALID_DATE_FORMAT'))
    : null,
  remark: [P.remark] ? Yup.string().max(255).nullable() : '',
});

export default function Occupieddischarge({
  allData,
  closePop,
  open,
  className,
  updateBedStatus,
  saveBedStatus,
  saveReturnDayCase,
  reload,
}) {
  const loginInfo = useSelector((state) => state.loginInfo);
  const [sendBtn, setSendBtn] = useState(false);
  const disabledData = {
    hospitalNo: true,
    hospitalCode: true,
    retrieve: true,
    name: true,
    age: true,
    specialtyCode: true,
    gender: true,
    ward: true,
    bedNo: true,
  };
  const transferOutSchema = {
    hospitalNo: true,
    hospitalCode: true,
    name: true,
    age: true,
    gender: true,
    status: Boolean(sendBtn),
  };
  const getCurrentWard = () => {
    const admDtmM = moment(allData?.[P.currentWard_admDtm]);
    const isVaild = admDtmM.isValid();
    const startTime = admDtmM.format('YYYY-MM-DD');
    const endTime = moment().format('YYYY-MM-DD');
    const DiffDay = moment(endTime).diff(startTime, 'days');
    return isVaild ? DiffDay : '';
  };

  const [ValueData, setValueData] = useState({
    [P.missing]: Boolean(allData?.[P.missingCaseCloseTime]),
    date: moment(initValue(allData?.[P.missingCaseCloseTime], undefined)),
    time: moment(initValue(allData?.[P.missingCaseCloseTime], undefined)),
    dateHomeLeave: allData?.[P.homeLeaveDtm] ? moment(allData?.[P.homeLeaveDtm]) : moment().add(1, 'd'),
    timeHomeLeave: allData?.[P.homeLeaveDtm] ? moment(allData?.[P.homeLeaveDtm]) : moment().hours(12).minutes(0),
    remark: '',
  });
  useEffect(() => {
    setValueData({
      ...ValueData,
      date: allData?.[P.missingCaseCloseTime] ? moment(allData?.[P.missingCaseCloseTime]) : moment(),
      time: allData?.[P.missingCaseCloseTime] ? moment(allData?.[P.missingCaseCloseTime]) : moment(),
    });
    setErrorMsg({ ...errorMsg, date: null, time: null });
  }, [ValueData[P.missing]]);

  useEffect(
    () => {
      setValueData({
        ...ValueData,
        dateHomeLeave: allData?.[P.homeLeaveDtm] ? moment(allData?.[P.homeLeaveDtm]) : moment().add(1, 'd'),
        timeHomeLeave: allData?.[P.homeLeaveDtm] ? moment(allData?.[P.homeLeaveDtm]) : moment().hours(12).minutes(0),
        remark: allData?.[P.remark] ?? '',
      });
      setErrorMsg({ ...errorMsg, dateHomeLeave: null, timeHomeLeave: null });
    },
    [ValueData[P.homeLeaveDtm]],
    ValueData[P.remark]
  ); // 1.
  const [errorMsg, setErrorMsg] = useState(null);
  const [returnDayCaseConfirmationPop, setReturnDayCaseConfirmationPop] = useState(false);

  useEffect(() => {
    setValueData({
      ...ValueData,
      [P.missing]: allData?.[P.missing],
      [P.homeLeaveDtm]: allData?.[P.homeLeaveDtm], // 4.
    });
  }, [allData]);

  const schema = initSchema();

  const onChangeHandle = (type, key) => {
    return (event) => {
      if (type === 'text') {
        setValueData({ ...ValueData, [key]: event.target.value });
      } else if (type === 'check') {
        setValueData({ ...ValueData, [key]: Number(event.target.checked) });
      } else if (type === 'select') {
        setValueData({ ...ValueData, [key]: event });
      } else if (type === 'date') {
        const newData = { ...ValueData, [key]: event };
        setValueData(newData);
        (async () => {
          await focusCheck(key, newData)();
        })();
      }
    };
  };
  const baseClasses = baseCssOccupieddischarge();
  const classes = useStyles();

  const [DischargeconfirmationPop, setDischargeconfirmationPop] = useState(false);
  const closeDischargeconfirmationPop = () => {
    setDischargeconfirmationPop(false);
  };
  const opensetDischargeconfirmationPop = () => {
    setDischargeconfirmationPop(true);
  };
  const [transferOutType, setTransferOutType] = useState(allData?.transferOutRequestInfo);
  const returnDayCaseHandel = async (type) => {
    //  type: return day case:1 ,  cancel return day case:2
    try {
      if (type === 1) {
        setReturnDayCaseConfirmationPop(true);
      } else {
        await saveReturnDayCase({ act: type, bedStatusId: allData?.bedStatusId, wardId: loginInfo.wardId }, closePop);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const returnDayCaseConfirmHandle = async (data) => {
    await saveReturnDayCase(
      { act: 1, bedStatusId: allData?.bedStatusId, wardId: loginInfo.wardId, remark: data.remark },
      closePop
    );
    closePop();
  };

  const closeReturnDayCaseConfirmation = () => {
    setReturnDayCaseConfirmationPop(false);
  };

  const cancelTransferOutHandelApi = useCallback(async () => {
    try {
      const { result } = await bedStatusAPI.postCancelTransferOut({ bedStatusId: allData?.bedStatusId });
      if (result === 'success') {
        setTransferOutType(null);
        eventBus.emit('BSRELOAD');
        if (isFunction(reload)) {
          reload();
        }
      }
    } catch (error) {}
  }, []);
  const saveHandle = async () => {
    try {
      ValueData[P.missing] && (await checkSubmitData(Yup.object().shape(schema), ValueData));
      setErrorMsg({ ...errorMsg, date: null, time: null });
      if (dateTimeMsg) return;
      try {
        await saveBedStatus(
          {
            ...allData,
            remarkType: remarkType.occupieddischarge,
            [P.missingCaseCloseTime]: ValueData[P.missing]
              ? moment(
                  moment(ValueData.date, 'D/MM/yyyy').format('yyyy-MM-DD') + ValueData.time.format('HH:mm:ss'),
                  'yyyy-MM-DD HH:mm:ss'
                ).valueOf()
              : 0,
            [P.homeLeaveDtm]: ValueData[P.homeLeaveDtm] // 2.
              ? moment(
                  moment(ValueData.dateHomeLeave, 'D/MM/yyyy').format('yyyy-MM-DD') +
                    ValueData.timeHomeLeave.format('HH:mm:ss'),
                  'yyyy-MM-DD HH:mm:ss'
                ).valueOf()
              : 0,
            remark: ValueData[P.remark],
          },

          closePop
        );
      } catch (e) {}
    } catch (e) {
      setErrorMsg({ ...errorMsg, ...e });
    }
  };

  const comfirmHandle = async (data) => {
    console.log('comfirmHandle', { ...ValueData, ...data });
    try {
      await updateBedStatus(
        {
          ...allData,
          // ...ValueData,
          ...data,
          targetStatus: bsApp.DISCHARGING,
          sourceStatus: bsApp.OCCUPIED,
        },
        closePop
      );
    } catch {}
  };

  const focusCheck = (name, value) => {
    return async () => {
      try {
        await checkSubmitData(Yup.object().shape({ [name]: schema[name] }), { [name]: ValueData[name] });
        setErrorMsg({ ...errorMsg, [name]: null });
      } catch (e) {
        setErrorMsg({ ...errorMsg, ...e });
      }
    };
  };
  const dateTimeMsg = useMemo(() => {
    if (ValueData?.[P.missing] && ValueData?.date.isValid() && ValueData?.time.isValid()) {
      const temp = ValueData.date.clone();
      temp.set('hour', ValueData.time.get('hour'));
      temp.set('minute', ValueData.time.get('minute'));
      return temp.isSameOrBefore(moment(), 'minute')
        ? null
        : i18n.t('BEDSTATUS_MISSING_DATE_AND_TIME_CANNOT_BE_LATER_THAN_CURRENT_TIME');
    }
    return null;
  }, [ValueData, i18n]);

  const [transferOutPop, setTransferOutPop] = useState(false);
  const [transferOutDetail, setTransferOutDetail] = useState(null);
  const [transferInPop, setTransferInPop] = useState(false);
  const [transferInDetail, setTransferInDetail] = useState(null);
  const [transferOutDetailBoolean, setTransferOutDetailBoolean] = useState(false);

  const getBsTransferOutRequestDetailApi = useCallback(async () => {
    try {
      const { result } = await bedStatusAPI.getBsTransferOutRequestDetail({
        transferRequestId: allData?.transferOutRequestInfo?.transferRequestId,
      });
      setTransferOutDetail(result);
    } catch (error) {}
  }, []);

  const getBsTransferInRequestDetailApi = useCallback(async () => {
    try {
      const { result } = await bedStatusAPI.getBsTransferRequestDetail({
        transferRequestId: allData?.transferInRequestInfo?.transferRequestId,
      });
      setTransferInDetail(result);
    } catch (error) {}
  }, []);

  const [bsMlookupList, setBsMlookupList] = useState(null);

  const getBsMlookupListApi = async () => {
    try {
      const getBsMlookupList = await bedStatusAPI.getBsMlookupList();
      setBsMlookupList(getBsMlookupList.result);
    } catch (error) {
      console.log('-----Ward error-----', error);
    }
  };

  const transferOutPopHandel = async () => {
    await getBsMlookupListApi();
    setSendBtn(true);
    setTransferOutDetailBoolean(false);
    setTransferOutPop(true);
  };
  const closeTransferOutPop = () => {
    setTransferOutPop(false);
  };

  const openTransferIn = async () => {
    await getBsMlookupListApi();
    await getBsTransferInRequestDetailApi();
    setTransferInPop(true);
  };

  const closeTransferInPop = () => {
    setTransferInPop(false);
  };

  const openTransferOut = async () => {
    await getBsMlookupListApi();
    await getBsTransferOutRequestDetailApi();
    setSendBtn(false);
    setTransferOutDetailBoolean(true);
    setTransferOutPop(true);
  };

  const saveHandleTransferOutPop = async (requestVal) => {
    try {
      await bedStatusAPI.postCreateBsTransferOutRequest({
        ...requestVal,
        wardId: loginInfo.wardId,
        patientKey: allData?.patientKey,
        bedStatusId: allData?.bedStatusId,
      });
      if (isFunction(reload)) {
        reload();
      }
      eventBus.emit('BSRELOAD');
      setTransferOutPop(false);
      closePop();
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };

  const bsMlookupListStatus = useMemo(() => {
    let addStatus = [
      { lookUpName: i18n.t('BEDSTATUS_PENDING'), lookUpValue: 'P' },
      { lookUpName: i18n.t('BEDSTATUS_DELETED'), lookUpValue: 'D' },
    ];
    return addStatus;
  }, [bsMlookupList]);

  const bsMlookupListTransferInStatus = useMemo(() => {
    let addStatus = [
      { lookUpName: i18n.t('BEDSTATUS_OUTSTANDING'), lookUpValue: 'O' },
      { lookUpName: i18n.t('BEDSTATUS_COMPLETED_SINCE_24HOURS_AGO'), lookUpValue: 'C' },
      { lookUpName: i18n.t('BEDSTATUS_DELETED'), lookUpValue: 'D' },
    ];
    return addStatus;
  }, [bsMlookupList]);

  // update
  const editSaveHandle = async (requestVal) => {
    try {
      await bedStatusAPI.postUpdateBsTransferOutRequest(requestVal);
      eventBus.emit('BSRELOAD');
      closePop();
      return true;
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };

  const editTransferInSaveHandle = async (requestVal, editIndex) => {
    console.log('------edit------', JSON.stringify(requestVal));
    try {
      await bedStatusAPI.postUpdateBsBooking(requestVal);
      eventBus.emit('BSRELOAD');
      closePop();
      return true;
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };

  const linkedBeds = useMemo(() => {
    if (allData.linkeds) {
      return [
        { value: `${allData.ccWardCd} ${allData.bedNo}`, flag: Boolean(allData.caseNo) },
        ..._.map(allData.linkeds, (item) => ({ value: `${item.ccWardCd} ${item.bedNo}`, flag: Boolean(item.caseNo) })),
      ];
    } else {
      return [];
    }
  }, [allData]);

  const patientName = admissionUtil?.useGetName({
    chiName: allData?.patInfo?.chiName,
    engName: allData?.patInfo?.engName,
    loginFlag: loginInfo?.flag,
    returnFormat: 'obj',
  });

  return (
    <>
      {!DischargeconfirmationPop && !transferOutPop && !transferInPop && !returnDayCaseConfirmationPop && (
        <Dialog open={open} className={classes.dialog} maxWidth={false}>
          <div className={classes.root}>
            <Box overflow="auto" p="0 1.56rem" display="flex" height="100%">
              <Box className={classes.left}>
                {/* <Typography className={baseClasses.headerTitle}>{i18n.t('BEDSTATUS_BED_STATUS')}</Typography> */}
                <div
                  className={classNames(baseClasses.statusBox, classes.statusBox)}
                  style={{ height: 'auto !important', padding: '1rem 0' }}
                >
                  <Box display="flex" flexDirection="column">
                    <div className={baseClasses.status}>
                      <BedStatusIcon allData={allData} disabled={true} />
                    </div>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center" pr="1.5rem" width="100%">
                    <PatientUI
                      iconBoxSize="2rem"
                      caseNo={initValue(allData?.[P.patientID], i18n.t('BEDSTATUS_N_A'))}
                      name={patientName?.fullName}
                      gender={allData?.[P.gender]}
                      age={initValue(allData?.[P.age], i18n.t('BEDSTATUS_N_A'))}
                      ehAddrInfo={allData?.[P.elderlyHome]}
                    />
                    {allData.linkeds && (
                      <Box display="flex" flexDirection="column">
                        <div className={baseClasses.labelText}>Linked Bed</div>
                        <div className={baseClasses.statusText}>
                          {linkedBeds.map((item, index) => (
                            <span style={{ color: item.flag ? '#538fff' : '#7d86a9' }} key={item.value}>{`${
                              item.value
                            }${index < linkedBeds.length - 1 ? ', ' : ''}`}</span>
                          ))}
                        </div>
                      </Box>
                    )}
                  </Box>
                </div>
                <Box display="flex" mt="1.188rem">
                  <div className={baseClasses.columnBox} style={{ paddingLeft: '1.875rem', marginRight: '1.25rem' }}>
                    <Typography className={baseClasses.labelText}>{i18n.t('BEDSTATUS_CURRENT_WARD')}</Typography>
                    <Typography className={baseClasses.statusText}>{allData?.[P.totalDats] ?? ''}</Typography>
                  </div>
                  <div className={baseClasses.columnBox} style={{ paddingLeft: '1.875rem' }}>
                    <Typography className={baseClasses.labelText}>{i18n.t('BEDSTATUS_TOTAL_DAYS')}</Typography>
                    <Typography className={baseClasses.statusText}>{getCurrentWard()}</Typography>
                  </div>
                </Box>
                <Box display="flex" alignItems="baseline" minHeight="10rem" height="100%">
                  <Box width="50%" marginRight="1.25rem">
                    <Typography className={classes.isolationPrecaution}>
                      {i18n.t('BEDSTATUS_ISOLATION_PRECAUTION')}
                    </Typography>
                    {getLsolationPrecaution(classes, allData)}
                    {allData?.covidPositivePat && (
                      <>
                        <Box display="flex">
                          <Typography className={classes.attentionItemLabel}>
                            {i18n.t('BEDSTATUS_REPORT_TIME')}
                          </Typography>

                          <Typography className={classes.attentionItem}>
                            {/* COVID info: {allData.covidPositivePat?.[0].covidDescription} */}
                            {allData?.covidPositivePat
                              ? moment(allData?.covidPositivePat?.[0].reportDtm).format('DD MMMM YYYY HH:MM')
                              : ''}
                          </Typography>
                        </Box>
                        <Box display="flex">
                          <Typography className={classes.attentionItemLabel}>
                            {i18n.t('BEDSTATUS_CT_VALUE')}{' '}
                          </Typography>
                          <Typography className={classes.attentionItem}>
                            {allData?.covidPositivePat?.[0].ctValue}
                          </Typography>
                        </Box>
                        <Box display="flex">
                          <Typography className={classes.attentionItem}>
                            {allData?.covidPositivePat?.[0].covidDescription}
                          </Typography>
                        </Box>
                        <Box display="flex">
                          <Typography className={classes.attentionItemLabel}>{i18n.t('BEDSTATUS_COUNTER')}</Typography>
                          <Typography className={classes.attentionItem}>
                            {allData?.covidPositivePat && (
                              <>
                                {Math.round(
                                  (moment().valueOf() - allData?.covidPositivePat?.[0].reportDtm) /
                                    (24 * 60 * 60 * 1000)
                                )}
                                {i18n.t('BEDSTATUS_DAY')}
                              </>
                            )}
                          </Typography>
                        </Box>
                      </>
                    )}
                  </Box>
                  <Box width="50%">
                    <Typography className={classes.isolationPrecaution} style={{ margin: '1.75rem 0 0.35rem 0' }}>
                      {i18n.t('BEDSTATUS_ATTENTION')}
                    </Typography>
                    <Box className={classes.attentionItem}>{getAttention(classes, allData)}</Box>
                  </Box>
                </Box>
                <Box marginTop="1.5rem">
                  <Text color="#7d86a9" fontSize="1rem">
                    MDRO Alert / CMS Alert
                  </Text>
                  {isNotEmptyArray(allData?.[bedP?.mdroInfo]) || isNotEmptyArray(allData?.[bedP?.cmsAlertInfos]) ? (
                    <>
                      <Box display="flex" flexWrap="wrap" mt="0.62rem" gridGap="0.62rem">
                        {allData?.[bedP?.mdroInfo]?.map((item) => (
                          <MdroInfo content={item.alertDesc} key={item.alertDesc} popValue={item} />
                        ))}
                      </Box>
                      <CmsAlert alertsData={allData?.[bedP?.cmsAlertInfos]} variant={CMS_ALERT_ICON_VARIANT.WIDE} />
                    </>
                  ) : (
                    '--'
                  )}
                </Box>
                <OrderedCleaningService
                  marginLeft="0"
                  marginTop="1rem"
                  tableName="B"
                  tableId={allData?.bedStatusId}
                  bedNo={allData?.bedNo}
                  reminder={`bed ${allData?.bedNo}`}
                />
              </Box>

              <Box className={classes.right}>
                <Box className={classes.closeIconBox}>
                  <IconButton className={classNames(baseClasses.closeIcon, classes.closeIcon)} onClick={closePop}>
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Box display="flex">
                  <Box width="50%" marginRight="1.5rem">
                    {/* <Typography className={classes.isolationPrecaution} style={{ margin: '0.6rem 0 0.35rem 0' }}>
                    {i18n.t('BEDSTATUS_RETURN_DAY_CASE')}
                  </Typography>
                  <Typography className={classes.attentionItem}>
                    {allData?.returnDayCaseType === 0 ? i18n.t('BEDSTATUS_N_A') : 'Yes'}
                  </Typography> */}
                    <Typography className={classes.isolationPrecaution} style={{ margin: '0.6rem 0 0.35rem 0' }}>
                      {i18n.t('BEDSTATUS_PENDING_ADMISSION_POPUP')}
                    </Typography>
                    {allData?.transferInRequestInfo ? (
                      <>
                        <Box display="flex" alignItems="center" className={classes.attentionItem}>
                          <div>
                            <span className={classes.rightSpace}>
                              {moment(allData?.transferInRequestInfo?.admissionDate).format('yyyy-MM-DD HH:mm')}
                            </span>
                            <span className={classes.rightSpace}>{allData?.transferInRequestInfo?.hospCode}</span>
                            <span>{allData?.transferInRequestInfo?.wardCode}</span>
                          </div>
                          <ButtonBase
                            className={classes.seeBtn}
                            onClick={() => {
                              (async () => {
                                await openTransferIn();
                              })();
                            }}
                          >
                            <SeeIcon className={classes.seeIcon} />
                          </ButtonBase>
                        </Box>
                        {allData?.transferInRequestInfo?.remark && (
                          <Box className={classes.attentionItem} style={{ color: '#7d86a9', fontSize: '0.875rem' }}>
                            {i18n.t('BEDSTATUS_RETURN_DAY_CASE')}: {allData?.transferInRequestInfo?.remark}
                          </Box>
                        )}
                      </>
                    ) : (
                      <Typography className={classes.attentionItem}>{i18n.t('BEDSTATUS_N_A')}</Typography>
                    )}
                  </Box>

                  <Box width="50%">
                    <Typography className={classes.isolationPrecaution} style={{ margin: '0.6rem 0 0.35rem 0' }}>
                      {i18n.t('BEDSTATUS_TRANSFER_OUT_BUTTON')}
                    </Typography>
                    {allData?.transferOutRequestInfo ? (
                      <Box display="flex" alignItems="center" className={classes.attentionItem}>
                        <div>
                          <span className={classes.rightSpace}>
                            {moment(allData?.transferOutRequestInfo?.admissionDate).format('yyyy-MM-DD HH:mm')}
                          </span>
                          <span className={classes.rightSpace}>{allData?.transferOutRequestInfo?.destHospCode}</span>
                          <span>{allData?.transferOutRequestInfo?.destWardCode}</span>
                        </div>
                        <ButtonBase
                          className={classes.seeBtn}
                          onClick={() => {
                            (async () => {
                              await openTransferOut();
                            })();
                          }}
                        >
                          <SeeIcon className={classes.seeIcon} />
                        </ButtonBase>
                      </Box>
                    ) : (
                      <Typography className={classes.attentionItem}>{i18n.t('BEDSTATUS_N_A')}</Typography>
                    )}
                  </Box>
                </Box>
                <Box className={classes.remarksBox}>
                  <Typography className={classes.remarksTitle} style={{ margin: '0.5rem 0 1rem 0' }}>
                    {i18n.t('BEDSTATUS_REMARKS')}
                  </Typography>
                  <Box>
                    <TextField
                      id={P.remark}
                      className={classNames(classes.remarksTextField, errorMsg?.remark ? classes.error : '')}
                      multiline={true}
                      onChange={onChangeHandle('text', P.remark)}
                      placeholder={i18n.t('BEDSTATUS_ADD_REMARKS_HERE')}
                      style={{ marginTop: '0.3rem' }}
                      rows={5}
                      inputProps={{
                        maxLength: 255,
                      }}
                      value={ValueData?.remark}
                      onBlur={() => {
                        (async () => {
                          await focusCheck(P.remark)();
                        })();
                      }}
                    />
                    {Boolean(errorMsg?.remark) && (
                      <Typography className={classes.errorMsg}>{errorMsg?.remark}</Typography>
                    )}
                  </Box>
                  <FormControlLabel
                    id="bed_occupieddischarge_missing"
                    control={<Checkbox />}
                    label={i18n.t('BEDSTATUS_MISSING')}
                    className={baseClasses.checkBox}
                    checked={Boolean(ValueData[P.missing])}
                    onChange={onChangeHandle('check', P.missing)}
                  />

                  <div style={{ visibility: ValueData[P.missing] ? 'visible' : 'hidden' }}>
                    <Box display="flex">
                      <Box width="50%" mr="1.25rem" id="bed_occupieddischarge_date_group">
                        <KeyboardDatePicker
                          id="bed_occupieddischarge_date"
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          invalidDateMessage={null}
                          format="yyyy-MM-DD"
                          value={ValueData.date}
                          disabled={!ValueData[P.missing]}
                          className={classes.datepicker}
                          keyboardIcon={
                            <div className={classNames(baseClasses.dateIcon, classes.dateIcon)}>
                              <DateIcon />
                            </div>
                          }
                          onChange={onChangeHandle('date', 'date')}
                          placeholder={i18n.t('BEDSTATUS_TIME')}
                          disableFuture={true}
                          maxDateMessage=""
                        />
                        {Boolean(errorMsg?.date) && (
                          <Typography className={classes.errorMsg}>{errorMsg.date}</Typography>
                        )}
                      </Box>
                      <Box width="50%">
                        <KeyboardTimeInput
                          id="bed_occupieddischarge_time"
                          className={classNames(classes.keyboardTimeInput)}
                          value={ValueData.time}
                          placeholder={i18n.t('BEDSTATUS_SELECT_TIME')}
                          onChange={onChangeHandle('date', 'time')}
                          disabled={!ValueData[P.missing]}
                        />
                        {Boolean(errorMsg?.time) && (
                          <Typography className={classes.errorMsg}>{errorMsg.time}</Typography>
                        )}
                      </Box>
                    </Box>
                    {Boolean(dateTimeMsg) && <Typography className={classes.errorMsg}>{dateTimeMsg}</Typography>}
                  </div>
                  <Box display="flex" alignItems="center">
                    <FormControlLabel
                      id="bed_occupieddischarge_home_leave"
                      control={<Checkbox />}
                      label={`${i18n.t('BEDSTATUS_HOME_LEAVE_HOME')}(${i18n.t('BEDSTATUS_RETURN_DATE')})`}
                      className={baseClasses.checkBox}
                      checked={Boolean(ValueData[P.homeLeaveDtm])} // 3.
                      onChange={onChangeHandle('check', P.homeLeaveDtm)}
                    />
                    <Box className={classes.returnedDate}>
                      {ValueData[P.homeLeaveDtm] && allData?.returnDtm
                        ? `(Returned Date: ${moment(allData?.returnDtm).format('YYYY-MM-DD')})`
                        : ''}
                    </Box>
                  </Box>

                  {/* <Typography display="flex">2023-02-10</Typography> */}
                  <div style={{ visibility: ValueData[P.homeLeaveDtm] ? 'visible' : 'hidden' }}>
                    <Box display="flex">
                      <Box width="50%" mr="1.25rem" id="bed_occupieddischarge_date_group_home_leave">
                        <KeyboardDatePicker
                          id="bed_occupieddischarge_date_home_leave"
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          invalidDateMessage={null}
                          format="yyyy-MM-DD"
                          value={ValueData.dateHomeLeave}
                          disabled={!ValueData[P.homeLeaveDtm]}
                          className={classes.datepicker}
                          keyboardIcon={
                            <div className={classNames(baseClasses.dateIcon, classes.dateIcon)}>
                              <DateIcon />
                            </div>
                          }
                          onChange={onChangeHandle('date', 'dateHomeLeave')}
                          placeholder={i18n.t('BEDSTATUS_TIME')}
                          maxDateMessage=""
                          // minDate={allData?.[P.homeLeaveDtm] ? '' : moment().add(1, 'd')}
                          minDate={moment()}
                          disablePast
                          error={false}
                          helperText={null}
                        />
                        {Boolean(errorMsg?.date) && (
                          <Typography className={classes.errorMsg}>{errorMsg.date}</Typography>
                        )}
                      </Box>
                      <Box width="50%">
                        <KeyboardTimeInput
                          id="bed_occupieddischarge_time_home_leave"
                          className={classNames(classes.keyboardTimeInput)}
                          value={ValueData.timeHomeLeave}
                          placeholder={i18n.t('BEDSTATUS_SELECT_TIME')}
                          onChange={onChangeHandle('date', 'timeHomeLeave')}
                          disabled={!ValueData[P.homeLeaveDtm]}
                        />
                        {Boolean(errorMsg?.time) && (
                          <Typography className={classes.errorMsg}>{errorMsg.time}</Typography>
                        )}
                      </Box>
                    </Box>
                  </div>
                  <Box display="flex" justifyContent="flex-end">
                    <ButtonBase
                      id="bed_occupieddischarge_save_remark"
                      className={classes.saveRemark}
                      onClick={() => {
                        (async () => {
                          await saveHandle();
                        })();
                      }}
                      style={{ marginRight: '1.25rem' }}
                    >
                      {i18n.t('BEDSTATUS_SAVE_REMARK')}
                    </ButtonBase>
                  </Box>
                  {/* <InputBase className={classes.inputBase} onChange={onChangeHandle('text', P.homeLeaveRemark)} /> */}
                </Box>
              </Box>
            </Box>

            <div className={baseClasses.bottom} style={{ boxShadow: '0 -1px 0 0 #e4e7eb', gap: '1.25rem' }}>
              {allData?.returnDayCase === 'N' && (
                <ButtonBase
                  id="bed_occupieddischarge_return_day_case"
                  className={classNames(classes.configBtn, classes.colorGreen)}
                  onClick={() => {
                    (async () => {
                      await returnDayCaseHandel(1);
                    })();
                  }}
                >
                  {i18n.t('BEDSTATUS_RETURN_DAY_CASE')}
                </ButtonBase>
              )}
              {allData?.returnDayCase === 'Y' && (
                <ButtonBase
                  id="bed_occupieddischarge_return_day_case"
                  className={classNames(classes.configBtn, classes.colorRed)}
                  onClick={() => {
                    (async () => {
                      await returnDayCaseHandel(2);
                    })();
                  }}
                >
                  {i18n.t('BEDSTATUS_CANCEL_RETURN_DAY_CASE')}
                </ButtonBase>
              )}
              {transferOutType ? (
                <ButtonBase
                  id="bed_cancel_transfer_out"
                  className={classNames(classes.configBtn, classes.colorBabyBlue)}
                  onClick={() => {
                    (async () => {
                      await cancelTransferOutHandelApi();
                    })();
                  }}
                  style={{ backgroundColor: '#ff7270' }}
                >
                  {i18n.t('BEDSTATUS_TRANSFER_CANCEL_OUT_BUTTON')}
                </ButtonBase>
              ) : (
                <ButtonBase
                  id="bed_occupieddischarge_transfer_out"
                  className={classNames(classes.configBtn, classes.colorBabyBlue)}
                  onClick={() => {
                    (async () => {
                      await transferOutPopHandel();
                    })();
                  }}
                >
                  {i18n.t('BEDSTATUS_TRANSFER_OUT_BUTTON')}
                </ButtonBase>
              )}
              <ServiceOrderBtn
                hospCode={allData?.ccHosp}
                wardLocation={allData?.ccWardLocation}
                version={allData?.version}
                status={allData?.status}
                tableId={allData?.bedStatusId}
                tableName="B"
                closePop={closePop}
                reminder={`bed ${allData.linkedBedNo ?? allData?.bedNo}`}
                allData={allData}
                defaultLocation={`${allData.ccWardLocation} ${allData.ccWardCd ?? allData?.wardCd}`}
                defaultCleaningCase={handleGetBsCleansingType(allData)}
                defaultRemark={`${allData?.ccWardCd ?? allData?.wardCd} 床 ${allData?.bedNo}`}
              />
              <ButtonBase
                id="bed_occupieddischarge_order_discharge"
                className={classNames(classes.configBtn, classes.colorBlue)}
                onClick={opensetDischargeconfirmationPop}
              >
                {i18n.t('BEDSTATUS_ORDER_DISCHARGE')}
              </ButtonBase>
            </div>
          </div>
        </Dialog>
      )}
      {Boolean(DischargeconfirmationPop) && (
        <Dischargeconfirmation
          allData={allData}
          closePop={closeDischargeconfirmationPop}
          open={DischargeconfirmationPop}
          comfirmHandle={comfirmHandle}
          P={P}
          onChangeHandle={onChangeHandle}
          ValueData={ValueData}
          hospCode={allData?.ccHosp}
          wardLocation={allData?.ccWardLocation}
          defaultLocation={`${allData.ccWardLocation} ${allData.ccWardCd}`}
        />
      )}
      {transferOutPop && (
        <TransferOutPop
          open={transferOutPop}
          closePop={closeTransferOutPop}
          bsMlookupList={bsMlookupList}
          allData={
            transferOutDetail && transferOutDetailBoolean
              ? transferOutDetail
              : {
                  ...allData,
                  wardCd: '',
                  status: 'P',
                  attention: bsAttentionFunc.getSortNameStr(allData?.attention, allData?.attention),
                  patName: patientName?.nameEn,
                  chiName: patientName?.nameZh,
                }
          }
          title={i18n.t('BEDSTATUS_TRANSFER_OUT_BUTTON')}
          disabledData={disabledData}
          transferOutSchema={transferOutSchema}
          sendBtn={sendBtn}
          saveHandle={sendBtn ? saveHandleTransferOutPop : editSaveHandle}
          bsMlookupListStatus={bsMlookupListStatus}
          covidPositivePatRemarks={sendBtn}
        />
      )}
      {transferInPop && (
        <Newbooking
          open={transferInPop}
          title={i18n.t('BEDSTATUS_TRANSFER_IN')}
          closePop={closeTransferInPop}
          bsMlookupList={bsMlookupList}
          allData={transferInDetail}
          bsMlookupListStatus={bsMlookupListTransferInStatus}
          saveHandle={editTransferInSaveHandle}
        />
      )}
      {returnDayCaseConfirmationPop && (
        <ReturnDayCaseConfirmation
          open={returnDayCaseConfirmationPop}
          returnDayCaseConfirmHandle={returnDayCaseConfirmHandle}
          closePop={closeReturnDayCaseConfirmation}
        />
      )}
    </>
  );
}
